export default class DateInputMaskHelper {

    static applyMaskDate(oldDateString, newDateString) {
        if (!newDateString) {
            return '';
        }

        const dateWithoutSlashes = newDateString ? newDateString.replace(/\//g, '') : '';
        const numberOfSlashes = newDateString && newDateString.match(/\//g) ? newDateString.match(/\//g).length : 0;

        if (!DateInputMaskHelper.isStringValid(dateWithoutSlashes, numberOfSlashes)) {
            return oldDateString;
        }

        if (dateWithoutSlashes.length >= 3 && dateWithoutSlashes.length < 5 && numberOfSlashes === 0) {
            return `${newDateString.substr(0, 2)}/${newDateString.substr(2)}`;
        }

        if (dateWithoutSlashes.length >= 5 && numberOfSlashes === 0) {
            return `${newDateString.substr(0, 2)}/${newDateString.substr(2, 2)}/${newDateString.substr(4)}`;
        }

        if (dateWithoutSlashes.length >= 5 && numberOfSlashes === 1 && newDateString.indexOf('/') === 2) {
            return `${newDateString.substr(0, 5)}/${newDateString.substr(5)}`;
        }

        if (dateWithoutSlashes.length >= 5 && numberOfSlashes === 1 && newDateString.indexOf('/') === 1) {
            return `${newDateString.substr(0, 4)}/${newDateString.substr(4)}`;
        }

        return newDateString;
    }

    static isStringValid(dateWithoutSlashes, numberOfSlashes) {
        // First rule: should not have more than 2 slashes
        if (numberOfSlashes > 2) {
            return false;
        }

        // Second rule: should not have only slashes
        if (!dateWithoutSlashes) {
            return false;
        }

        // Third rule: should not have more than 8 digits (not counting the slashes)
        if (dateWithoutSlashes.length > 8) {
            return false;
        }

        // Fourth rule: without slashes, should be a number
        return !isNaN(dateWithoutSlashes);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/DateInputMaskHelper.js